var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([
    {
      margin: `${_vm.$smallAppBarHeight} ${_vm.$globalSideMargin} 0`,
      position: 'relative'
    },
    _vm.$breakpoints.mdAndUp && {
      margin: `${_vm.$getScaledCssValue('25px')} ${_vm.$globalSideMargin} 0`
    }
  ])},[_c('img',{style:([
      // Values found with trial and error
      {
        position: 'absolute',
        opacity: 0.05,
        zIndex: 0,
        top: '52px',
        left: '50%',
        transform: 'translate(42%, 0)',
        display: 'block',
        objectFit: 'contain',
        height: 'calc(100% - 52px)'
      },
      _vm.$breakpoints.smAndDown && {
        height: '500px',
        opacity: 0.02,
        top: '200px',
        left: '100%',
        transform: 'translate(-30%, 0)'
      }
    ]),attrs:{"src":""}}),_c('div',{style:([
      {
        position: 'relative',
        gridTemplateColumns: `1fr`,
        maxWidth: _vm.$maxWidth,
        margin: '0 auto'
      },
      _vm.$breakpoints.mdAndUp && {
        display: 'grid',
        gridTemplateColumns: `${_vm.$getScaledCssValue('327px')} 1fr`
      }
    ])},[(_vm.showSidebar && _vm.$breakpoints.mdAndUp)?_c('SimpleSidebar',{staticClass:"mb-2",style:({
        gridColumn: 'span 1',
        justifySelf: 'start',
        alignSelf: 'stretch',
        justifySelf: 'stretch'
      }),attrs:{"sidebarData":_vm.sidebarData},on:{"update:selectedSidebarItems":_vm.updateItems}}):_vm._e(),_c('div',{class:{ 'd-flex flex-column align-stretch': _vm.$breakpoints.smAndDown },style:([
        {},
        _vm.$breakpoints.mdAndUp && {
          gridColumn: _vm.showSidebar ? 'span 1' : 'span 2',
          marginLeft: _vm.showSidebar ? _vm.$getScaledCssValue('24px') : null
        }
      ])},[_c('div',{staticClass:"rounded white",style:([
          {
            boxShadow: `0 ${_vm.$getScaledCssValue('6px')} ${_vm.$getScaledCssValue(
              '20px'
            )} #AAAAAA65`,
            margin: `0 -${_vm.$globalSideMargin}`,
            padding: `0 ${_vm.$globalSideMargin} 16px`,
            position: 'relative'
          },
          _vm.$breakpoints.mdAndUp && {
            margin: 0,
            padding: `${_vm.$getScaledCssValue('36px')} ${_vm.$getScaledCssValue(
              '54px'
            )}`,
            position: 'static'
          }
        ])},[(_vm.$breakpoints.smAndDown)?_c('div',{style:({
            position: 'absolute',
            top: '-30px',
            left: '0',
            width: '100%',
            height: '30px',
            backgroundColor: 'white'
          })}):_vm._e(),_vm._t("searchForm",function(){return [_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.$emit('formSubmitted')}}},[_c('div',{staticClass:"d-flex flex-column"},[_c('SearchInput',{staticStyle:{"outline":"none !important","padding-block":"1em"},style:({
                  marginBottom: _vm.$getScaledCssValue('22px')
                }),attrs:{"id":"searchInput","value":_vm.searchTerm},on:{"input":function($event){return _vm.$emit('update:searchTerm', $event)},"undo-clicked":_vm.undoClicked}}),_c('div',{class:{
                  'd-flex justify-space-between': true,
                  'flex-column': _vm.$breakpoints.smAndDown
                }},[_c('div',{staticClass:"d-flex",style:({ flexGrow: '1' })},[_vm._t("searchDropdowns")],2),_c('div',{class:{ 'align-self-center': _vm.$breakpoints.smAndDown }},[_c('SearchButton',{on:{"click":function($event){return _vm.$emit('formSubmitted')}}})],1)])],1)])]}),_c('div',{staticClass:"mt-2 d-flex flex-wrap"},[_vm._t("activeFilters")],2)],2),(_vm.$breakpoints.smAndDown)?_c('div',{staticClass:"d-flex justify-center",style:({
          position: 'relative',
          zIndex: '2',
          margin: `0 -${_vm.$globalSideMargin}`
        })},[_c('div',{staticClass:"secondary",style:({
            padding: '8px 24px 16px',
            borderRadius: '0 0 32px 32px',
            position: 'relative',
            zIndex: '2',
            cursor: 'pointer'
          }),on:{"click":function($event){_vm.smallScreenFiltersOpen = !_vm.smallScreenFiltersOpen}}},[_c('Arrow',{class:_vm.smallScreenFiltersOpen ? 'up' : 'down',style:({
              borderColor: 'white',
              transition: 'transform 300ms ease-in-out'
            }),attrs:{"borderWidth":"2px","width":"8px"}})],1),_c('div',{style:({
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            transition:
              'transform 300ms ease-in-out, opacity 300ms ease-in-out',
            transform: `scaleY(${_vm.smallScreenFiltersOpen ? '1' : '0'})`,
            opacity: _vm.smallScreenFiltersOpen ? 1 : 0,
            transformOrigin: 'top center'
          })},[_c('SimpleSidebar',{attrs:{"sidebarData":_vm.sidebarData},on:{"update:selectedSidebarItems":_vm.updateItems}})],1)]):_vm._e(),_c('div',{style:({
          overflowY: 'scroll',
          overflowX: 'visible',
          scrollbarWidth: 'none',
          minHeight: _vm.$getScaledCssValue('747px'),
          padding: `${_vm.$getScaledCssValue('18px')} ${_vm.$getScaledCssValue(
            '20px'
          )} 0`,
          margin: `40px ${_vm.$getScaledCssValue('-20px')}`,
          position: 'relative'
        })},[_c('div',{staticClass:"list-items-container",style:({
            position: 'relative'
          })},[_vm._t("listItems")],2)])]),(
        _vm.itemObjects &&
        _vm.itemObjects.length > 0
      )?_c('Pagination',{style:([
        { margin: '40px 0' },
        _vm.$breakpoints.mdAndUp && {
          margin: `${_vm.$getScaledCssValue('50px')} 0 ${_vm.$getScaledCssValue(
            '50px'
          )} ${_vm.$getScaledCssValue('24px')}`,
          gridColumn: _vm.showSidebar ? '2 / 3' : 'span 2'
        }
      ]),attrs:{"currentPage":_vm.currentPage,"totalPages":_vm.totalPages},on:{"input":function($event){return _vm.$emit('update:currentPage', $event)}}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }